"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable*/
exports.default = {
  "login": {
    "onlineTraining": "Plataforma de formación en línea Liaogao e Academy",
    "captchaNotEmpty": "se debe completar el código de verificación",
    "accountNotEmpty": "La cuenta no puede estar vacía",
    "passwordBits": "La longitud de la contraseña no puede ser inferior a 6 dígitos",
    "incorrectTips": "Nombre de usuario o contraseña ingresados ​​incorrectamente",
    "sign": "iniciar sesión",
    "passwordNotEmpty": "la contraseña no puede estar en blanco",
    "passwordBitsLong": "La longitud de la contraseña no puede ser superior a 18 dígitos",
    "captchaTips": "código de verificación incorrecto",
    "confirmNot": "La contraseña ingresada es inconsistente con la contraseña confirmada",
    "inputAccount": "Ingrese el nombre de usuario",
    "inputPassword": "Por favor, ingrese contraseña",
    "inputCaptcha": "por favor ingrese el código de verificación",
    "forgetPassword": "contraseña olvidada",
    "nextStep": "Próximo paso",
    "inputUserName": "por favor ingrese el nombre de usuario",
    "phoneNumber": "número de teléfono",
    "phoneEmpty": "El número de teléfono no puede estar vacío",
    "surePasswordEmpty": "confirmar la contraseña no puede estar en blanco",
    "userNameEmpty": "El nombre de usuario no puede estar vacío",
    "getCaptcha": "obtener el código de verificación",
    "msgCaptcha": "Código de verificación por SMS",
    "prevStep": "Anterior",
    "surePassword": "Por favor, confirme su contraseña",
    "reset": "Reiniciar",
    "resetSuccess": "Restablecer con éxito",
    "resetSuccessTips": "Ha restablecido correctamente su contraseña, vaya a iniciar sesión",
    "loginNow": "Regístrate",
    "copyRight": "Los derechos de autor son propiedad de × × × × × × × × × × × × × × × × × × × × ×",
    "loginFail": "¡Acceso fallido. Por favor intente nuevamente!",
    "captchaFail": "Error en la verificación del código de verificación",
    "failTips": "Fallo en la verificación",
    "inputOrigPassword": "Ingrese la contraseña original",
    "inputNewPassowrd": "Ingrese una nueva contraseña",
    "confimPassword": "Por favor, confirme su contraseña",
    "sure": "determinar",
    "cancel": "cancelar",
    "changePasswordSuccess": "la contraseña ha sido actualizada",
    "continueLogin": "volver a registrarse",
    "resetLoginTips": "Ha cambiado correctamente su contraseña, debe iniciar sesión nuevamente y cerrar sesión automáticamente después de 3 segundos",
    "passwordFormat": "La longitud de la contraseña es de 8 a 32 dígitos, incluidos números y letras mayúsculas y minúsculas",
    "changePassword": "Cambia la contraseña",
    "poor": "débiles",
    "middle": "en",
    "strong": "Fuerte",
    "logout": "Cerrar sesión correctamente",
    "formerPhone": "Número de teléfono original",
    "newPhone": "Nuevo número de teléfono",
    "changePhoneSuccess": "Número de teléfono móvil modificado correctamente",
    "changePhoneSuccessTips": "Has modificado correctamente tu número de teléfono",
    "goHome": "Ir a la página de inicio",
    "changePhone": "Modificar el número de teléfono móvil",
    "newPhoneEmpty": "El nuevo número de teléfono no puede estar vacío",
    "newPhoneFomat": "El nuevo formato del número de teléfono es incorrecto",
    "newPhoneSupport": "El nuevo número de teléfono no puede ser el mismo que el número de teléfono original.",
    "newPhoneBinded": "Se ha vinculado un nuevo número de teléfono",
    "orgPhoneEmpty": "El número de teléfono original no puede estar vacío",
    "orgPhoneFormat": "El formato del número de teléfono original es incorrecto",
    "orgPhoneNot": "El número de teléfono original es incorrecto.",
    "resetPassword": "restablecer la contraseña",
    "phoneCaptchaEmpty": "El código de verificación del teléfono no puede estar vacío",
    "accountVerif": "Verificación de la cuenta",
    "phoneVerif": "Verificación de teléfono",
    "resetDone": "Reinicio completo",
    "phoneFormat": "El formato del número de teléfono no es correcto",
    "phoneBinded": "El número de teléfono móvil ha sido vinculado",
    "loginVertif": "Autenticación de inicio de sesión",
    "clickGoHome": "Haga clic para volver a la página de inicio de sesión",
    "bingPhoneSuccess": "Vincular el número de teléfono móvil correctamente",
    "rightMessageChange": "Puede editarlo en la información personal en el lado derecho de la barra de navegación",
    "bingPhone": "Vincular número de teléfono móvil"
  },
  "index": {
    "setAsHomePage": "Configurar como portada",
    "addCollection": "Agregar a los favoritos",
    "telephone": "línea directa de soporte",
    "Help": "Centro de ayuda",
    "SystemMessage": "Recordatorio del sistema",
    "message": "Noticias",
    "emptyMessage": "Vacío",
    "checkAllMessage": "ver todo",
    "noMessage": "Sin datos",
    "fullScreen": "Visualización de pantalla completa",
    "ExitSystem": "Salir de este sistema",
    "back": "regreso",
    "top": "parte superior",
    "backToTop": "Volver arriba",
    "homePage": "Casa",
    "course": "Aprendizaje del curso",
    "onlineCourse": "Clase especial en línea",
    "faceCourse": "Entrenamiento presencial",
    "examPractice": "Práctica de examen",
    "dataDownLoad": "Descargar",
    "userInfo": "Centro personal",
    "Administration": "Experiencia en gestión",
    "courseCategory": "clases de cursos",
    "examIsOver": "La evaluación está completa",
    "onlineHours": "Horas online",
    "faceHours": "Horas de clases presenciales",
    "notice": "anuncio",
    "checkAllNotice": "ver todo",
    "backToTopButton": "Volver arriba",
    "recommendCourse": "Cursos recomendados",
    "impotentCourse": "Curso clave",
    "newCourse": "Últimos cursos",
    "hotCourse": "Curso más caliente",
    "requiredCourses": "Curso obligatorio",
    "electiveCourses": "Curso electivo",
    "startStudy": "empezar a aprender",
    "continueStudy": "Seguir estudiando",
    "coursesRanking": "Clasificación de selección de cursos",
    "studentRanking": "Clasificaciones de estudiantes",
    "currentUser": "Usuario actual",
    "userHead": "foto de perfil",
    "currentHead": "Avatar actual",
    "change": "modificar",
    "accountPassword": "contraseña de la cuenta",
    "encryPhone": "Teléfono secreto",
    "currentPhone": "Teléfono actual",
    "userName": "nombre de usuario",
    "head": "Avatar",
    "coverImage": "Imagen de portada",
    "uploadError": "subida fallida",
    "autoSetHomeTips": "Su navegador no admite la configuración automática de la página de inicio, utilice el menú del navegador para configurarla manualmente.",
    "operateConfig": "El navegador rechaza esta operación. Si desea habilitar esta función, ingrese about: config en la barra de direcciones y luego establezca el valor deigned.applets.codebase_principal_support en true.",
    "favoriteTips": "Debido a la limitación de la función del navegador 360, presione Ctrl + D para marcar manualmente.",
    "autoFavorite": "Su navegador no lo admite, presione Ctrl + D para marcar manualmente.",
    "required": "Este artículo es obligatorio",
    "to": "a",
    "trainingTime": "periodo de entrenamiento",
    "coursehours": "Horas de clase",
    "human": "personas",
    "wecome": "¡Bienvenido!",
    "allCourses": "Todos los cursos"
  },
  "course": {
    "coursesCategory": "clases de cursos",
    "allCourses": "Todos los cursos",
    "electiveCourses": "Cursos electivos",
    "requiredCourses": "Cursos requeridos",
    "collect": "Favoritos",
    "cancelCollect": "No favorito",
    "searchTips": "Ingrese el nombre del curso",
    "startStudy": "empezar a aprender",
    "continueStudy": "Seguir estudiando",
    "cancelConfirm": "No favorito",
    "cancelTips": "Confirmar para cancelar la solicitud",
    "confirmButton": "Botón cancelar",
    "count": "Total",
    "item": "Artículo",
    "up": "Pagina anterior",
    "next": "Siguiente página",
    "items": "Artículo / Página",
    "go": "Salta a",
    "page": "página",
    "man": "personas",
    "score": "Minuto",
    "courseYear": "año",
    "courseTeachers": "profesor",
    "noDesc": "Sin introducción",
    "teachersDesc": "Perfil del profesor",
    "checkLog": "Ver registros",
    "reExam": "Volver a probar",
    "examLog": "Registro de examen",
    "viewPaper": "Ver papel de prueba",
    "noPublicExam": "El papel de prueba no se anunciará",
    "marking": "Calificación",
    "closeButton": "apagar",
    "examResultPage": "Página de resultados del examen",
    "examPage": "Página de examen",
    "startExam": "Iniciar examen",
    "coursehours": "Horas de clase",
    "courseInfo": "Detalles del curso",
    "courseChapter": "Capítulos del curso",
    "courseNote": "Notas del curso",
    "courseData": "Información del curso",
    "courseExamination": "Examen",
    "evaluate": "Evaluación",
    "courseEvaluate": "Evaluación del curso",
    "no": "primero",
    "chapter": "capítulo",
    "isEvaluate": "Evaluado",
    "uploadDate": "Tiempo de carga",
    "className": "Nombre de la clase",
    "resourceSize": "Tamaño del recurso",
    "times": "Veces",
    "typeViedo": "vídeo",
    "typeImage": "imagen",
    "typeDoc": "Documentación",
    "typeOuth": "otro",
    "typeImages": "Varias imágenes",
    "newComment": "A hoy",
    "hotComment": "Más caliente",
    "openComment": "Quiero comentar",
    "cancelButton": "cancelar",
    "publishButton": "lanzamiento",
    "commentTips": "Ingrese el contenido del comentario",
    "emptyCommentTips": "El contenido del comentario no puede estar vacío",
    "noteSource": "Desde",
    "deleteNoteButton": "Eliminar",
    "needIETips": "¡El curso actual requiere un navegador IE!",
    "donwNum": "tiempos de descarga",
    "preview": "Avance",
    "relatedCourses": "Cursos relacionados",
    "studentsNum": "Numero de cursos",
    "courseHours": "Horas del curso",
    "JoinLearning": "Únete al aprendizaje"
  },
  "onlineclass": {
    "allTheClass": "Todas las clases",
    "beginClass": "Inicio de clases",
    "notBeginClass": "Sin clase",
    "endClass": "Cerrado",
    "searchThoseClass": "Busque la clase especial en línea que le interesa",
    "startLearn": "Entrar en la clase",
    "registrationTime": "tiempo de registro",
    "to": "a",
    "trainingTime": "periodo de entrenamiento",
    "subjectsClass": "Cursos",
    "classStudy": "Estudio de clase",
    "quantityOfCourses": "Numero de cursos",
    "numberOfParticipants": "Numero de aplicantes",
    "registerNow": "Regístrate ahora",
    "resetRegister": "Retirar el nombre",
    "participating": "Han participado",
    "subjects": "puerta",
    "classExam": "Examen de clase",
    "notParticipat": "No involucrado",
    "startExim": "Iniciar examen",
    "handed": "realizar una tarea",
    "score": "Puntuación",
    "cacheSave": "Almacenamiento temporal",
    "subjectsNumber": "Numero de puertas",
    "notice": "aviso",
    "communication": "comunicación",
    "detail": "Detalles",
    "courses": "curso",
    "allClass": "Todos",
    "compulsory": "Obligatorio",
    "elective": "Electivo",
    "Learned": "Aprendido",
    "classPassIndicator": "Indicadores de aprobación de clase",
    "excellence": "excelente",
    "compulsoryNumber": "Número de pase obligatorio",
    "electiveNumber": "Número de electivas aprobadas",
    "compulsoryStandard": "Horas estándar obligatorias",
    "electiveStandard": "Horas electivas",
    "examIsPass": "Si el examen pasó",
    "resource": "Recursos",
    "source": "datos",
    "new": "A hoy",
    "hot": "Más caliente",
    "updateTime": "Tiempo de carga",
    "downloadCount": "Descargas",
    "download": "descargar",
    "resourceSize": "Tamaño del recurso",
    "resourceType": "Tipos de",
    "allType": "Todos los tipos",
    "videos": "vídeo",
    "images": "imagen",
    "document": "Documentación",
    "others": "otro",
    "multiImages": "Varias imágenes",
    "inforCertificate": "certificado",
    "notSubmit": "no enviado",
    "submitHomework": "enviar tarea",
    "submitTime": "Tiempo de presentación",
    "uploadHomework": "Subir tarea",
    "clickHere": "haga clic aquí",
    "upload": "Subir",
    "formatSupport": "Soporte de formato de archivo",
    "submited": "presentado",
    "notApproved": "Sin revisar",
    "approved": "examen aprobado",
    "downloadHomework": "Descargar tarea",
    "reSubmit": "Reenviar",
    "myScore": "Mi puntaje",
    "comments": "Comentarios",
    "talk": "discutir",
    "category": "clasificación",
    "classTalk": "Discusión en clase",
    "groupTalk": "discusión de grupo",
    "wantTalk": "Quiero discutir",
    "publish": "lanzamiento",
    "undo": "cancelar",
    "delete": "Eliminar",
    "iknow": "Lo tengo",
    "faceCourseClass": "Entrenamiento presencial",
    "onlineClasses": "Clase especial en línea",
    "openReservation": "Abierto para registro",
    "talkTech": "conferenciante",
    "address": "ubicación",
    "up": "en",
    "noon": "Mediodía",
    "down": "debajo",
    "even": "tarde",
    "classOvered": "Clase cerrada",
    "nopassed": "Aún no registrado",
    "inputTalkContent": "Ingrese el contenido de la discusión",
    "groupMan": "Lider de grupo",
    "showAllGroup": "Ver todos los miembros",
    "hideAllGroup": "Aparta a todos los miembros del equipo",
    "showAllMan": "Ver todos los estudiantes",
    "hideAllMan": "Aparta a todos los estudiantes",
    "reply": "Respuesta",
    "isDelete": "¿Estás seguro de eliminarlo?",
    "cancelLike": "diferente a",
    "classNotStar": "El registro de la clase aún no ha comenzado",
    "classIsEnd": "El registro de la clase ha finalizado",
    "clickReset": "Haga clic en el botón para eliminar el nombre",
    "agentRegister": "Regístrese de nuevo",
    "cancelRegister": "Cancelar registro",
    "reason": "la razón",
    "inputReason": "Ingrese el motivo de la revocación",
    "homework": "operación",
    "leaveMaxBits": "El motivo de la solicitud de licencia no puede superar las 100 palabras.",
    "leaveNotEndTime": "La hora de inicio de la licencia no puede ser igual a la hora de finalización",
    "sizeNot": "El tamaño no puede exceder",
    "close": "apagar",
    "teacher": "profesor",
    "noIntroduction": "Sin introducción"
  },
  "offlineclass": {
    "fullTimeToFace": "Instrucción presencial a tiempo completo",
    "onlineToFace": "En el trabajo",
    "allClass": "Todas las clases",
    "openClass": "Clase abierta",
    "searchThoseClass": "Busque cursos de formación presenciales que le interesen",
    "startLearn": "Entrar en aprendizaje",
    "classHours": "Horas de clase",
    "h": "Hora",
    "firstWeek": "Semana 1",
    "askLeave": "Quiero despedirme",
    "monday": "lunes",
    "tuesday": "martes",
    "wednesday": "miércoles",
    "thursday": "jueves",
    "fridays": "viernes",
    "saturdays": "en sábado",
    "sunday": "el domingo",
    "morning": "Mañana",
    "afternoon": "por la tarde",
    "evening": "Por la noche",
    "leaveType": "Tipo de licencia",
    "selectLeaveType": "Seleccione el tipo de licencia",
    "leaveTime": "Tiempo libre",
    "selctLeaveTime": "Seleccione el tiempo de salida",
    "reasonLeave": "Razón para irse",
    "inputReasonLeave": "Ingrese el motivo de la baja",
    "sure": "determinar",
    "selectTime": "período de selección",
    "casualLeave": "Permiso personal",
    "sickLeave": "baja por enfermedad",
    "seven": "día",
    "one": "Uno",
    "two": "dos",
    "three": "Tres",
    "for": "cuatro",
    "five": "Fives",
    "six": "seis",
    "clear": "Vacío",
    "evaluating": "Evaluación",
    "courseEvaluation": "Evaluación docente",
    "inputEvaluating": "Ingrese el contenido de la evaluación",
    "beDoing": "En progreso",
    "notStarted": "no ha comenzado",
    "evaluationInProgress": "Evaluación en curso",
    "notEvaluation": "No evaluado",
    "evaluationStartTime": "Hora de inicio de la evaluación",
    "startEvaluation": "Iniciar evaluación",
    "classEvaluation": "Evaluación de la clase",
    "photoCategory": "Clasificación de álbumes",
    "learningActivity": "Actividad de aprendizaje",
    "addPhoto": "Nuevas fotos agregadas",
    "photoMessage": "Información de la foto",
    "photoName": "Nombre de la foto",
    "inputPhotoName": "Ingrese el nombre de la foto",
    "uploadPhoto": "Carga de fotos",
    "formatSupport": "Soporte de formato de soporte",
    "tickets": "Zhang",
    "group": "grupo",
    "notGroup": "desclasificado",
    "groupTalk": "Discusión de grupo",
    "teacherAbout": "Perfil del profesor",
    "teacherTech": "Cursos tomados",
    "photos": "album de fotos",
    "phontoRequier": "Las fotos deben cargarse",
    "addPhoneTips": "Agregado con éxito, espere la revisión",
    "sureDelete": "estas seguro que quieres borrarlo",
    "deleteSuccess": "eliminado con éxito",
    "phoneNameReq": "El campo del nombre de la foto es obligatorio",
    "longNotBits": "La longitud no puede exceder los 50 caracteres.",
    "phoneIsOccur": "El nombre de la foto ya existe",
    "evaluateTime": "Tiempo de evaluación",
    "evalueteNotStar": "La evaluación no ha comenzado",
    "evaluateEnds": "La evaluación ha terminado",
    "isEvaluated": "Juzgado",
    "at": "en",
    "submit": "enviar",
    "seeEvalute": "Ver evaluación",
    "inputIdea": "Por favor ingrese sus pensamientos",
    "submitFailure": "No se pudo entregar",
    "seeRecord": "Ver registros",
    "examRecord": "Registro de examen",
    "seeSubmite": "Ver papel de prueba",
    "resultPage": "Página de resultados del examen",
    "hoursStandard": "No se puede realizar el examen si las horas de clase no cumplen con el estándar",
    "examPage": "Página de examen",
    "questionnaire": "Cuestionario",
    " coursesTaught": "Cursos impartidos",
    "passed": "por",
    "is": "si",
    "not": "No",
    "passedState": "Estado de pase",
    "sketch": "sequía",
    "partySchool": "Clase de entrenamiento de la escuela de fiestas",
    "searchPartySchool": "Busque la clase de formación de la escuela de fiestas que le interese"
  },
  "exam": {
    "answerWarning": "La pregunta de este examen es una sola pregunta irreversible, tenga cuidado antes de la siguiente pregunta",
    "inputAnswerTips": "Por favor escriba su respuesta",
    "problemPoints": "Análisis del problema",
    "examination": "Regístrese para un examen",
    "knowledgeCompetition": "Concurso de conocimientos",
    "practice": "Práctica autónoma",
    "notRegister": "No registrado",
    "reviewAudit": "bajo revisión",
    "auditNoPass": "Error de auditoría",
    "participanted": "registrado",
    "participant": "Regístrate",
    "examTime": "tiempo de examen",
    "examHours": "duración",
    "registration": "Regístrate exitosamente",
    "reRegistration": "Retirar el nombre",
    "wrongQuestion": "Banco de preguntas incorrecto",
    "noInvolvement": "No involucrado",
    "involvement": "Participó",
    "searchExamPractice": "Busque exámenes y ejercicios que le interesen",
    "practiced": "Experto",
    "startPractice": "Empezar a practicar",
    "toFavorite": "Agregar a los favoritos",
    "prevPrevious": "Pregunta anterior",
    "nextPrevious": "próxima pregunta",
    "submitAnswers": "Enviar respuesta",
    "rightAnswers": "respuesta correcta",
    "yourAnswers": "tu respuesta",
    "questionsAnalysis": "Análisis de preguntas",
    "noAnalysis": "Sin resolución",
    "accuracy": "Tasa correcta",
    "continuePracticed": "Sigue practicando",
    "topics": "tema"
  },
  "source": {
    "allResource": "Todos los recursos",
    "commonResource": "Recursos generales",
    "classResource": "Recursos de clase",
    "resourceCategory": "Clasificación de recursos",
    "searchResource": "Busque los recursos que le interesan",
    "resourceTalk": "Evaluación de recursos",
    "previewResource": "Vista previa de recursos",
    "helpPoint": "Manual de ayuda",
    "isEvaluation": "¡Ya lo has evaluado!",
    "selectEvaluation": "¡No ha seleccionado una calificación!",
    "evaluationSuccess": "Evaluación exitosa",
    "topRelise": "Parte superior",
    "className": "Nombre de la clase",
    "resourceEvaluation": "Calificación de recursos"
  },
  "usercenter": {
    "386": "Archivo de aprendizaje",
    "myCourse": "Mis cursos",
    "hours": "Hora",
    "loginAccount": "Cuenta de inicio de sesión",
    "htllo": "Hola",
    "welcomeMessage": "Te deseo felicidad todos los días",
    "underway": "Tú lo estás haciendo",
    "annualAssessment": "Evaluación anual",
    "searchTips": "Ingrese el nombre del curso buscado",
    "completed": "Terminado",
    "allCourses": "Todos los cursos",
    "requiredCourses": "Cursos requeridos",
    "electiveCourses": "Cursos electivos",
    "all": "Todos",
    "ongoing": "Procesando",
    "learnTo": "Aprender a",
    "inExams": "Tomar el examen",
    "noExams": "Sin examen",
    "delete": "Eliminar",
    "pleaseSelect": "por favor elige",
    "searchOnlineTips": "Busque clases especiales en línea que le interesen",
    "passedCourse": "pasado",
    "failedCourse": "No pasó",
    "myOnlineCourse": "Mi clase especial online",
    "myFaceCourse": "Mi clase de formación presencial",
    "searchFaceTips": "Busca cursos que te interesen",
    "myExams": "Mi examen",
    "allExams": "Todos los exámenes",
    "makeUpExam": "Estar maquillado",
    "marking": "Calificación",
    "onExam": "Examen en curso",
    "passedExam": "Examen pasado",
    "examHours": "Duración del exámen",
    "examOver": "El examen ha terminado",
    "exam": "examen",
    "examLog": "Registro de examen",
    "myScore": "Mi puntaje",
    "surplusMakeUpExam": "Examen de recuperación restante",
    "times": "Veces",
    "searchExamTips": "Ingrese el nombre de la búsqueda",
    "haveTime": "Tiempo restante",
    "question": "pregunta",
    "eachQuestion": "Cada pregunta",
    "score": "Minuto",
    "examExplain": "Descripción del examen",
    "confirmHandExams": "Ya sea para confirmar la presentación",
    "autoSaveFailed": "Error al guardar automáticamente",
    "autoSaveSuccess": "Auto guardar",
    "handExamsSuccess": "Entregado con éxito",
    "yourScore": "Tu puntuación",
    "noPublicAnswers": "No se anunciarán las respuestas para este examen.",
    "noPublicResult": "El papel de prueba no se anunciará",
    "reExam": "Re examinar",
    "practice": "Ejercicio",
    "hasCollected": "recogido",
    "emptyAnswer": "El contenido de la opción o respuesta no puede estar vacío",
    "isCorrect": "Solución positiva",
    "myCollected": "mi colección",
    "courseCollected": "Colección de cursos",
    "examCollected": "Preguntas de prueba",
    "deleteCollected": "Eliminar favorito",
    "myLeave": "Mi permiso",
    "allLeave": "Todos se van",
    "needAudit": "Pendiente",
    "auditDate": "tiempo de aplicación",
    "searchLeaveTips": "Busque la licencia que le interesa",
    "checkInfo": "Ver detalles",
    "cancelLeave": "Revocar licencia",
    "leaveInfo": "Deja detalles",
    "leaveState": "Estado actual",
    "teamLeader": "Lider de grupo",
    "committeeMembers": "Comité de inspección de disciplina de la organización",
    "headmaster": "director",
    "schoolLeader": "Líder de la escuela",
    "student": "Aprendiz",
    "auditMessage": "Razón de la aprobación",
    "onBusiness": "Para negocios",
    "personal": "Por razones personales",
    "rejectReasons": "Motivo del rechazo",
    "confirmCancel": "Confirmar si revocar la licencia",
    "cancelButton": "Revocar",
    "cancelTitle": "Confirmación de revocación",
    "empty": "No",
    "wrongQuestionBank": "Mi banco de preguntas equivocado",
    "searchWrongTips": "Busque la pregunta incorrecta que le interese",
    "deleteWrongQuestion": "Eliminar el banco de preguntas incorrecto",
    "myQuestionnaire": "Mi cuestionario",
    "isCompleted": "terminado",
    "isOver": "terminado",
    "searchQuestionnaireTips": "Ingrese el nombre del cuestionario de búsqueda",
    "questionnaireDate": "Hora del cuestionario",
    "startQuestionnaire": "Empiece a responder",
    "checkQuestionnaire": "Ver cuestionario",
    "allTeacher": "Todos los profesores",
    "newTeacher": "Agregar profesor",
    "searchTeacherTips": "Busca profesores que te interesen",
    "checkTeacher": "Ver",
    "editTeacher": "editar",
    "workingIn": "Trabajó en",
    "location": "Ubicación permanente",
    "confirmDelete": "Eliminar confirmación",
    "confirmDeleteTips": "Confirmar eliminación",
    "recommendTeacher": "Recomendación del maestro",
    "addTeachers": "Nuevos profesores",
    "teacherInfo": "Informacion personal",
    "teacherName": "Nombre del maestro",
    "workUnit": "Empleador",
    "contact": "Detalles de contacto",
    "teacherNameTips": "Ingrese el nombre del profesor",
    "teacherWorkUnitTips": "Ingrese el empleador",
    "teacherContactTips": "Ingrese la información de contacto del maestro",
    "teacherLocationTips": "Ingrese la ubicación permanente",
    "teacherDescTips": "Introduzca el perfil del profesor",
    "teachingInfo": "Información didáctica",
    "teachingExpertise": "Experiencia docente",
    "fitLevel": "Adecuado para nivel de objeto didáctico",
    "fitBusiness": "Adecuado para líneas comerciales",
    "ruleNumber": "Ingrese un número entero de 8 dígitos (incluidos 8)",
    "rulePhone": "Por favor ingrese un número de teléfono válido",
    "ruleString": "Ingrese 80 caracteres (incluidos 80)",
    "ruleIsNumber": "Por favor ingrese el numero",
    "pause": "Almacenamiento temporal",
    "teachingStyle": "Estilo de conferencia",
    "teachingExpertiseTips": "Ingrese la experiencia docente del maestro",
    "fitLevelTips": "Seleccione el nivel que se adapte al público objetivo",
    "fitBusinessTips": "Elija una línea de negocio adecuada",
    "chargeInfoTips": "Ingrese el estándar de carga",
    "teachingStyleTips": "Introduzca el estilo de clase del profesor",
    "otherInfo": "Otra información",
    "recommendUnit": "Recomendado por",
    "otherOption": "Otros asuntos",
    "otherOptionTips": "Ingrese otras cosas que deben agregarse",
    "isRequired": "Este artículo es obligatorio",
    "pauseSuccess": "Guardado con éxito",
    "phoneWrong": "Por favor ingrese un número de teléfono válido",
    "junior": "Estudiante de secundaria",
    "highSchool": "Estudiante de preparatoria",
    "english": "Inglés",
    "mathematics": "matemáticas",
    "recommendSuccessTips": "Has enviado correctamente al profesor recomendado. Una vez aprobada la revisión, el profesor se añadirá al grupo de profesores.",
    "goBackrecommend": "Volver a la recomendación del maestro",
    "checkTeacherInfo": "Ver profesores",
    "currentState": "Estado actual",
    "chargeInfo": "Cargos",
    "myCertificate": "Mi certificado",
    "learningArchives": "Archivo de aprendizaje",
    "allCertificate": "Todos los certificados",
    "onlineCourse": "Clase en línea",
    "faceCourse": "Clase presencial",
    "exams": "examen",
    "baseInfo": "información básica",
    "userName": "nombre de usuario",
    "name": "Nombre",
    "company": "Unidad actual",
    "learningExperience": "Estudiar historia",
    "assessmentIndex": "Índice de evaluación",
    "assessmentStatus": "Estado de evaluación",
    "assessmentTime": "tiempo de prueba",
    "onlineLearning": "Aprender en línea",
    "year": "año",
    "faceOutProduceHours": "Instrucción presencial (horas de clase)",
    "notFaceOutProduceHours": "Instrucción presencial no profesional (horas de clase)",
    "onlineCenterLearnHours": "Aprendizaje intensivo en línea (horas de clase)",
    "onlineSelfLearnHours": "Autoaprendizaje online (horas de clase)",
    "outCompanyLearnHours": "Estudiar en el extranjero (horas de clase)",
    "allHours": "período total",
    "onlineSelfLearn": "Aprendizaje autónomo en línea",
    "onlineCentralizedLearning": "Aprendizaje intensivo en línea",
    "outCompanyLearn": "Estudio de unidad extranjera",
    "faceTrain": "Entrenamiento presencial",
    "myNotice": "Mi mensaje",
    "noticeSearchTips": "Busca noticias que te interesen",
    "systemNotice": "Recordatorio del sistema",
    "message": "Carta privada"
  },
  "questionnaire": {
    "notParticipat": "No involucrado",
    "description": "Descripción del cuestionario",
    "save": "salvar",
    "export": "Exportar",
    "printing": "impresión",
    "handed": "realizar una tarea",
    "topics": "tema",
    "examList": "Lista de preguntas de la prueba",
    "tableQuestions": "Pregunta de mesa",
    "newLine": "Añadir fila",
    "deleteLine": "Borrar fila",
    "sort": "Número de serie",
    "content": "contenido",
    "shortQuestion": "Respuesta corta",
    "inputContent": "Ingrese el contenido de la respuesta",
    "multiple": "Opción multiple",
    "single": "Opción multiple",
    "saveSuccess": "Guardado con éxito",
    "submitSuccess": "Enviado satisfactoriamente",
    "submitTips": "Ha enviado correctamente el cuestionario, gracias por su participación",
    "closePage": "Cerrar esta pagina"
  },
  "play": {
    "endStudy": "Fin de estudio",
    "tips": "Consejos",
    "playTips": "Recordatorio: para asegurarse de que el sistema registre su tiempo de estudio normalmente, haga clic en el botón \"Finalizar estudio\" en la esquina superior derecha para salir del estudio. Si cierra directamente el navegador, es posible que su tiempo de estudio no se registre normalmente.",
    "notShowAgain": "No vuelva a mostrar este mensaje",
    "gotIt": "Lo tengo",
    "chapter": "capítulo",
    "chapterText1": "primero",
    "chapterText2": "capítulo",
    "note": "notas",
    "noteBlockTitle": "notas",
    "evaluate": "Evaluación",
    "evaluateStar": "estrella",
    "saveEvaluate": "enviar",
    "notePlaceholder": "Por favor ingrese notas",
    "closeTips": "Es posible que el sistema no guarde sus cambios",
    "closeButton": "vete",
    "autoStop": "Deja de jugar automáticamente",
    "autoStopTips": "Debido a que no ha operado durante mucho tiempo, el sistema detuvo automáticamente la reproducción de video",
    "confirmOut": "¿Estás seguro de dejar de jugar?",
    "closeOrNot": "Si cerrar la ventana actual",
    "noCoursePlay": "No hay material didáctico reproducible en el curso actual",
    "attention": "¡Tenga en cuenta!"
  }
};